import React, { Component } from "react";
import { connect } from "react-redux";

import styled from "styled-components";
import { withFirebase } from "../Firebase";
import PropTypes from "prop-types";
import { Box, Flex, Heading, Text } from "rebass";
import { Avatar, Divider } from "reakit";
import { schoolSelectors } from "../../store/school";

const ProfileWrapper = styled.div`
  //min-width: 300px;
`;

const StyledLink = styled.a`
  text-decoration: none;
`;

StyledLink.defaultProps = {
  color: "#969a9b",
};

class FacultyProfileCard extends Component {
  state = {
    parents: [],
  };

  render() {
    const { profile } = this.props;
    
    return (
      <ProfileWrapper>
        <Flex flexWrap={"wrap"} p={1} mt={1} px={2}>
          <Box width={1}>
            <Flex>
              <Box>
                <Heading as={"h5"}>
                  {profile.first_name} {profile.last_name}
                </Heading>
              </Box>
              <Box ml={"auto"} />
              <Box>
                <Avatar
                  src={profile.profile_pic}
                  width={"70px"}
                  height={"70px"}
                  backgroundColor={"#707070"}
                />
              </Box>
            </Flex>
          </Box>
          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          <Flex width={1} py={3}>
            <Box width={1 / 2}>
              <Text marginTop="7px" fontSize={"16px"} fontWeight={600}>
                Title
              </Text>
            </Box>
            <Box ml={"auto"} />
            <Box>
              <Text color="#969a9b" fontSize={"16px"} fontWeight={600}>
                {profile.position}
              </Text>
            </Box>
          </Flex>

          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          <Flex width={1} py={3}>
            <Box width={1 / 2}>
              <Text marginTop="7px" fontSize={"16px"} fontWeight={600}>
                Email
              </Text>
            </Box>
            <Box ml={"auto"} />
            <Box>
              <Text color="#969a9b" fontSize={"16px"} fontWeight={600}>
                {profile.email}
              </Text>
            </Box>
          </Flex>

          <Box width={1} py={1}>
            <Divider padding={0} margin={0} />
          </Box>

          {/*<Flex width={1} py={3}>*/}
          {/*  <Box width={1 / 2}>*/}
          {/*    <Text marginTop="7px" fontSize={"16px"} fontWeight={600}>*/}
          {/*      Mobile*/}
          {/*    </Text>*/}
          {/*  </Box>*/}
          {/*  <Box ml={"auto"} />*/}
          {/*  <Box>*/}
          {/*    <StyledLink*/}
          {/*      href={`tel:${profile.mobile && profile.mobile.split("-").join("")}`}*/}
          {/*    >*/}
          {/*      <Text color="#969a9b" fontSize={"16px"} fontWeight={600}>*/}
          {/*        {profile.mobile}*/}
          {/*      </Text>*/}
          {/*    </StyledLink>*/}
          {/*  </Box>*/}
          {/*</Flex>*/}
          {/*<Box width={1} py={1}>*/}
          {/*  <Divider padding={0} margin={0} />*/}
          {/*</Box>*/}

        </Flex>
      </ProfileWrapper>
    );
  }
}

FacultyProfileCard.propTypes = {
  profile: PropTypes.object,
  type: PropTypes.string,
  isFaculty: PropTypes.bool,
};

FacultyProfileCard.defaultProps = {
  type: "Faculty",
};

const mapStateToProps = (state) => ({
  schoolInfo: schoolSelectors.refreshSchool(state.school),
});

export default withFirebase(connect(mapStateToProps)(FacultyProfileCard));
